'use client';

import React from 'react';
import { AnimatePresence, LazyMotion, m } from 'framer-motion';
import { domAnimation } from 'framer-motion';
export const HeaderSection = ({
  title,
  description,
  marginBottom = 45,
  classes = '',
  isLoading = false,
}: {
  title: string;
  description: string | React.ReactNode;
  marginBottom?: number;
  classes?: string;
  isLoading?: boolean;
}) => {
  return (
    <LazyMotion features={domAnimation} strict>
      <div style={{ marginBottom: `${marginBottom}px` }} className={classes}>
        <div className="relative w-full flex items-center min-h-[36px]">
          <AnimatePresence mode="wait">
            {isLoading ? (
              <m.div
                key="skeleton"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="absolute inset-0 flex items-center"
              >
                <div className="h-8 w-64 bg-ds-gray-subtler rounded animate-pulse" />
              </m.div>
            ) : (
              <m.h1
                key="title"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="ds-text-title-sm-semibold text-ds-text-default mb-0"
                aria-label={title}
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordBreak: 'break-word',
                  textOverflow: 'ellipsis',
                  maxHeight: '72px', // 2 lines at ~36px line height
                }}
              >
                {title}
              </m.h1>
            )}
          </AnimatePresence>
        </div>
        <div className="ds-text-body-sm-medium text-ds-text-subtle">
          {description}
        </div>
      </div>
    </LazyMotion>
  );
};
